import { render, staticRenderFns } from "./ApplianceModelUpdate.vue?vue&type=template&id=3b6bf510"
import script from "./ApplianceModelUpdate.vue?vue&type=script&lang=js"
export * from "./ApplianceModelUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports